module.exports = __webpack_public_path__ + "media/images/icons/likes-62ef48e80f536321ed57ebfe4cfb4c94.svg";